import React, { ReactNode } from 'react';
import { Checkbox, FormControlLabel, SxProps, Theme } from '@mui/material';

interface Props {
  readonly sx?: SxProps<Theme>;
  readonly values: readonly boolean[];
  readonly disabled?: boolean;
  readonly onChange: (newValue: boolean) => void;
  readonly label: ReactNode;
}

export function MultiValueBooleanInput(props: Props) {
  const some = props.values.some((value) => value);
  const every = props.values.every((value) => value);

  return (
    <FormControlLabel
      sx={props.sx}
      control={
        <Checkbox
          checked={every}
          indeterminate={some && !every}
          disabled={props.disabled}
          onChange={(_event, checked) => {
            props.onChange(checked);
          }}
        />
      }
      label={props.label}
    />
  );
}
